import { computedUnlimitedCallingPlans, computedPbxMeteredPlans, computedPbxBasePlans } from './service/computers/plans/pbx';
import { addToCart } from './service/flow/utils';
import _ from 'lodash';

/**
 * Get the PBX base plan that should be added when calling plans exist and pbx base plan doesn't exist
 * @param {Array} planList - The plan list to check
 * @param {Array} boughtPlans - The bought plans list
 * @returns {Object|null} The pay-as-you-go pbx base plan to add, or null if no plan should be added
 */
export const getDependentDefaultPbxBasePlan = (planList = [], boughtPlans = []) => {
  if (!planList || planList.length === 0) {
    return null;
  }

  // Get all calling plans (unlimited + metered) from planList
  const callingPlans = [
    ...computedUnlimitedCallingPlans(planList),
    ...computedPbxMeteredPlans(planList)
  ]

  // Check if any calling plan is selected
  const existCallingPlan = _.some(callingPlans, (p) => p?.cartInfo?.selected_number > 0);

  // Only proceed if calling plan exists
  if (!existCallingPlan) {
    return null;
  }

  // Get pbx base plans and check if any is selected
  const pbxBasePlans = computedPbxBasePlans(planList);
  const existPbxBasePlan = _.some(pbxBasePlans, (p) => p?.cartInfo?.selected_number > 0);
  const boughtPaidPbxBasePlans = _.filter(computedPbxBasePlans(boughtPlans), (p) => !(p.isFreeTrial || p.isOnlineFreeTrial));

  // if account has bought paid pbx base plan, do not add pbx base plan to cart
  if (boughtPaidPbxBasePlans?.length) {
    return null;
  }

  // Only add pbx base plan if calling plan exists and pbx base plan doesn't exist
  if (!existPbxBasePlan) {
    // Find the pay-as-you-go pbx base plan
    // Note: find() returns a reference to the original object in planList
    const paygPbxBasePlan = pbxBasePlans.find?.(plan => plan?.is_payg);
    return paygPbxBasePlan || null;
  }

  return null;
};

/**
 * Add PBX base plan when calling plans exist and pbx base plan doesn't exist
 * @param {Array} planList - The plan list to check and modify
 * @returns {Array} The modified plan list
 */
export const addDependentDefaultPbxBasePlan = (planList = [], boughtPlans = []) => {
  // Only add pbx base plan if calling plan exists and pbx base plan doesn't exist
  const paygPbxBasePlan = getDependentDefaultPbxBasePlan(planList, boughtPlans);
  if (paygPbxBasePlan) {
    addToCart(paygPbxBasePlan, 1);
  }

  return planList;
}
